import { personName } from 'Data/format.js'

export function getText(person) {
  return `The contract for ${personName(
    person
  )} has already been signed. To make changes to the payment plan, please remove the signature first.`
}
